import { forwardRef, type Ref, type SVGProps } from "react";

function SvgBlockCalendarWithDiamond(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width={62} height={54} fill="none" {...props}>
      <path
        fill="url(#BlockCalendarWithDiamond_svg__a)"
        d="M57 26c0-4.624-1.565-8.876-4.201-12.265L24.735 41.8A19.9 19.9 0 0 0 37 46v5a24.92 24.92 0 0 1-17.678-7.322A24.92 24.92 0 0 1 12 26C12 12.193 23.193 1 37 1a24.92 24.92 0 0 1 17.678 7.322A24.92 24.92 0 0 1 62 26c0 13.807-11.193 25-25 25v-5c11.046 0 20-8.954 20-20m-40 0c0 4.624 1.565 8.875 4.2 12.264L49.264 10.2A19.9 19.9 0 0 0 37 6c-11.046 0-20 8.954-20 20"
      />
      <path
        stroke="#0C1C43"
        strokeLinecap="square"
        d="M33.636 19.714V18m7.728 1.714V18m-7.728 5.143h7.728M32.727 33h9.546C43.779 33 45 31.849 45 30.429v-8.143c0-1.42-1.221-2.572-2.727-2.572h-9.546c-1.506 0-2.727 1.152-2.727 2.572v8.143C30 31.849 31.221 33 32.727 33Z"
      />
      <path
        fill="#B01921"
        d="M.38 3.538 6.647.09a.73.73 0 0 1 .706 0l6.267 3.447a.733.733 0 0 1 .25 1.058l-6.267 9.087a.732.732 0 0 1-1.206 0L.13 4.597a.733.733 0 0 1 .25-1.06Z"
      />
      <defs>
        <linearGradient
          id="BlockCalendarWithDiamond_svg__a"
          x1={37}
          x2={36.785}
          y1={1}
          y2={38.767}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#FCBDC1" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgBlockCalendarWithDiamond);
export default ForwardRef;
